import React from "react";
import { Box, Typography } from "@mui/material";
import { dsColorNew } from "@palette";

/** The rows are the direct webs or the brands inside a broker, depending on the toggle. */
export default function axisHeader(label) {

	return {
		setHeaderCellProps: () => ({
			sx: {
				backgroundColor: dsColorNew.tableHead,
				position: 'sticky',
				top: 0,
				left: 0,
				zIndex: '160 !important',
				border: 0,
				pl: 1.75,
				verticalAlign: 'bottom',
			}
		}),
		render: () => <Box sx={{ minWidth: 210, display: 'flex', alignItems: 'center', justifyContent: 'start', pb: 0.5 }}>
			<Typography sx={{ fontSize: 14, fontWeight: 700 }}>{label}</Typography>
		</Box>
	}
}
